<template>
  <div>
    <a-form layout="inline" :form="dataForm" @submit="getDataList" class="p-20">
      <a-form-item label="行程名称">
        <a-input v-model="dataForm.supplier_name" placeholder="行程名称" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
      </a-form-item>
      <a-form-item v-permission="['admin:trip:update']">
        <a-button type="primary" @click="addOrUpdateHandle({ trip_id: '', customer_id })">新增行程</a-button>
      </a-form-item>
    </a-form>
    <tripTable :x="1600" :columns="columns" :dataList="dataList" :dataListLoading="dataListLoading" @suodan="suodan"
      @addOrUpdateHandle="addOrUpdateHandle" @TripProjectClick="TripProjectClick" @TripOverClick="TripOverClick"
      @TripDeleteClick="deleteHandle">
    </tripTable>
    <a-pagination class="mt-20 float-right" show-size-changer :current="page" :total="total"
      :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange" @change="pageCurrentChangeHandle" />
    <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
    <TripProject ref="tripProject" @ok="getDataList"></TripProject>
    <TripOver ref="tripOver" @ok="query"></TripOver>
  </div>
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "./components/addorupdate.vue";
import TripProject from "@/components/TripProject/index.vue";
import TripOver from '@/components/TripOver/index.vue'
import tripTable from '@/components/TripProject/tripTable.vue'
export default {
  mixins: [viewModule],
  components: {
    addorupdate,
    TripProject,
    TripOver,
    tripTable
  },
  props: {
    customer_id: String,
  },
  watch: {
    customer_id(newValue) {
      this.dataForm.customer_id = newValue
      this.getDataList()
    }
  },
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/admin/trip/page",
        deleteURL: "/admin/trip/delete",
        deleteTitle: "是否确定删除当前选择行程？",
        deleteContent: "删除后对应会删除行程关联的所有数据（行程项目数据，行程付款数据，行程备注等）"
      },
      dataForm: {
        customer_id: this.customer_id,
      },
      columns: [
        {
          title: "行程名称",
          dataIndex: "trip_name",
          width: 120
        },
        {
          title: "出行次数",
          dataIndex: "playindextext",
          width: 100,
          scopedSlots: { customRender: "playindextext" },
        },
        {
          title: "行程人数",
          dataIndex: "person_length",
          width: 100,
          customRender: (text) => `${text}人`,
        },
        {
          title: "行程天数",
          dataIndex: "trip_days",
          width: 100,
          customRender: (text) => text.split(',').length + `天`,
        },
        {
          title: "是否锁单",
          dataIndex: "is_lock",
          width: 120,
          scopedSlots: { customRender: "is_lock" },
        },
        {
          title: "行程状态",
          dataIndex: "is_over_text",
          scopedSlots: { customRender: "is_over_text" },
          width: 120,
        },
        {
          title: "行程满意度",
          dataIndex: "satisfaction_level_text",
          width: 120,
        },
        {
          title: "订单时间",
          dataIndex: "trip_createtime",
          width: 200
        },
        {
          title: '合计售价',
          dataIndex: "price_total_all",
          width: 100
        },
        {
          title: '合计成本',
          dataIndex: "cost_total_all",
          width: 100
        },
        {
          title: '合计利润',
          dataIndex: "profit_total_all",
          width: 100
        },
        {
          title: "操作",
          scopedSlots: { customRender: "editBtn" },
          fixed: 'right'
        },
      ],
    };
  },
  methods: {
    addOrUpdateHandle({ trip_id, customer_id }) {
      this.$refs.addOrUpdate.init(trip_id, customer_id);
    },
    TripProjectClick(trip_id) {
      this.$refs.tripProject.init(trip_id);
    },
    TripOverClick(trip_id) {
      this.$refs.tripOver.init(trip_id)
    },
    //锁单或解单
    suodan(trip_id) {
      this.$http({
        url: "/admin/trip/lock",
        method: 'post',
        data: { trip_id }
      }).then(() => {
        this.$message.success('操作成功')
        this.getDataList()
      })
    }
  },
};
</script>

<style></style>